<template>
  <div class="flex bg-grey-900 rounded-b">
    <div
      class="w-64 flex-no-shrink py-2 px-4 whitespace-no-wrap font-bold text-white"
    >
      Supporting Documents
    </div>
    <div class="w-full flex justify-end">
      <progress-report-document
        v-for="interval in intervals"
        :key="interval.id"
        :documents="getDocuments(interval.id)"
        :interval="interval"
        :can-edit="isMsp || isMonitor || canEdit"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressReportDocuments",
  props: {
    documents: {
      type: [Object, Array],
      required: false,
      default() {
        return {};
      }
    },
    intervals: {
      type: Array,
      required: true
    },
    isMsp: {
      type: [Boolean, Function],
      default: false
    },
    isMonitor: {
      type: [Boolean, Function],
      default: false
    },
    canEdit: {
      type: [Boolean, Function],
      default: false
    }
  },
  methods: {
    getDocuments(id) {
      if (!this.documents.hasOwnProperty(id)) return [];
      return this.documents[id] || [];
    }
  }
};
</script>
